export default __webpack_public_path__ + "static/menu-icon-d23e4ff8f69dbbccff2b56371f7799c4.png";